module.exports = __webpack_public_path__ + "img/icon_store.22e330c8.svg";